module.exports = __webpack_public_path__ + "img/xen.4ce22596.png";